/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ExitInputs */



/**
* | output |
* | --- |
* | "Exit" |
*
* @param {ExitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exit = /** @type {((inputs?: ExitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ExitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quitter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausfahrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Uscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выход")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出口")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाहर निकलना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saída")
	return /** @type {LocalizedString} */ ("Exit")
});